import React from "react";
import { SEO, MainLayout, DeliveryType } from "../../../components";
const DeliveryTypePage = () => {
  return (
    <>
      <SEO title="delivery type" />
      <MainLayout>
        <DeliveryType />
      </MainLayout>
    </>
  );
};

export default DeliveryTypePage;
